import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'dw-ui-floating-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-container.component.html',
  styleUrl: './floating-container.component.css',
  animations: [
    trigger('pageAnimations', [
      transition('basic => hovered', [
        query(
          '.animated--slide-in',
          [
            style({ opacity: 0, transform: 'translateY(5px)' }),
            stagger(100, [
              animate('0.2s ease-out', style({ transform: 'translateY(0px)', opacity: 1 })),
            ]),
          ],
          { optional: true },
        ),
      ]),
      transition('hovered => basic', [
        query(
          '.animated--slide-in',
          [
            style({ opacity: 1, transform: 'translateY(0px)' }),
            stagger(100, [
              animate('0.2s ease-out', style({ opacity: 0, transform: 'translateY(5px)' })),
            ]),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class FloatingContainerComponent {
  isHovered = false;

  @HostListener('mouseleave') onMouseLeave() {
    this.isHovered = false;
  }

  onOver() {
    this.isHovered = true;
  }
}
